export default "__VITE_ASSET__ldJyVOnY__"